// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#checkbox.checkbox-container {\n  width: 30px;\n  height: 30px;\n  margin-right: 20px;\n  border: 1px solid var(--primary-200);\n}\n\n", ""]);
// Exports
module.exports = exports;
